import { Modal } from 'antd'
import * as MODAL from 'constant/modal'

const { confirm, error: errorModal, success: successModal } = Modal

const confirmModal = (handleSubmit, decide, outcome) =>
  confirm({
    cancelText: MODAL.DECIDE.CANCEL_TEXT,
    centered: true,
    content: decide.content,
    okText: MODAL.DECIDE.OK_TEXT,
    onOk: async () => {
      try {
        await handleSubmit()
        successModal({
          centered: true,
          content: outcome.content.success,
          okText: MODAL.OUTCOME.OK_TEXT,
          title: outcome.title.success
        })
      } catch (error) {
        console.error(error)
        errorModal({
          centered: true,
          content: typeof outcome.content.error === 'function' ? outcome.content.error(error) : outcome.content.error,
          okText: MODAL.OUTCOME.OK_TEXT,
          title: outcome.title.error
        })
      }
    },
    title: decide.title
  })

export default confirmModal
